import React from "react";
import classNames from "classnames";

interface CarouselButtonsProps {
    hideLeftButton: boolean;
    hideRightButton: boolean;
    isOrangeButtons: boolean;
    arrowColor: string;
    previousSlideAriaLabel: string;
    nextSlideAriaLabel: string;
    onLeftClick: () => void;
    onRightClick: () => void;
    customArrowColor?: string;
}

const CarouselButtons: React.FC<CarouselButtonsProps> = ({
    hideLeftButton,
    hideRightButton,
    isOrangeButtons,
    arrowColor,
    previousSlideAriaLabel,
    nextSlideAriaLabel,
    onLeftClick,
    onRightClick,
    customArrowColor,
}) => {
    const renderButton = (direction: "left" | "right", ariaLabel: string, onClick: () => void, disabled: boolean) => (
        <button
            className={classNames("Carousel__Swiper__Button", `Carousel__Swiper__Button--${direction}`, {
                "Carousel__Swiper__Button--orange": isOrangeButtons,
            })}
            onClick={onClick}
            aria-label={ariaLabel}
            disabled={disabled}
        >
            <svg
                className={classNames(
                    "Carousel__Swiper__Button__icon",
                    `Carousel__Swiper__Button__icon--${arrowColor}`,
                    { "Carousel__Swiper__Button__icon--hidden": disabled }
                )}
                width="45"
                height="32"
                viewBox="0 0 45 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <line
                    x1="0.89"
                    y1="16.25"
                    x2="44.01"
                    y2="16.25"
                    stroke={`${customArrowColor ? customArrowColor : "white"}`}
                    strokeWidth="2"
                />
                <line
                    x1="28.55"
                    y1="31.29"
                    x2="43.79"
                    y2="16.05"
                    stroke={`${customArrowColor ? customArrowColor : "white"}`}
                    strokeWidth="2"
                />
                <line
                    x1="28.83"
                    y1="1.29"
                    x2="44.07"
                    y2="16.54"
                    stroke={`${customArrowColor ? customArrowColor : "white"}`}
                    strokeWidth="2"
                />
            </svg>
        </button>
    );

    return (
        <>
            {renderButton("left", previousSlideAriaLabel, onLeftClick, hideLeftButton)}
            {renderButton("right", nextSlideAriaLabel, onRightClick, hideRightButton)}
        </>
    );
};

export default CarouselButtons;
